import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import CreateProductModal from 'shared/components/CreateProductModal';

const CreateProduct = () => {
  const navigate = useNavigate();
  const handleNavigateHome = () => {
    navigate(AppRoutes.PRODUCT);
  };
  useEffect(() => {
    localStorage.removeItem('create-processing-facility');
    localStorage.removeItem('scope1');
    localStorage.removeItem('scope2');
  }, []);
  return (
    <div>
      {/* <CreateProductModal
        handleModalCancel={handleNavigateHome}
        handleModalConfirm={() => {}}
        showModalState={true}
      /> */}
    </div>
  );
};

export default CreateProduct;
